import { GET_ALTERNATIVE_STORE } from '../../actionTypes/AlternativeStoreActionTypes'

const getAlternativeStore = payload => ({
  type: GET_ALTERNATIVE_STORE,
  payload
})

export { getAlternativeStore } // eslint-disable-line
